<template>
  <div>
    <popup-add-product
      v-if="stocktake"
      ref="popupAddProduct"
      @productSelected="productSelected"
      :existingProducts="stocktake.stockProductIds"
      :totalVenueStock="totalVenueStock"
    />

    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isActive"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <div class="flex items-center">
          <img width="40" :src="ProductIcon" class="mr-4" />
          <div>
            <h4>New stocktake</h4>
            <small v-if="existingStocktake"
              >Based on stocktake from
              <code>{{ existingStocktake.committed | date }}</code></small
            >
            <small v-if="!existingStocktake">Custom</small>
          </div>
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="isActive = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <Loading v-if="isLoading" />

        <div v-else class="p-6">
          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Deadline</span>
            </div>
            <div style="z-index: 999001">
              <v-date-picker
                v-model="stocktake.stocktakeDeadlineDate"
                mode="dateTime"
                is24hr
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <div class="flex justify-between">
                    <vs-input
                      name="Deadline"
                      :value="inputValue"
                      v-on="inputEvents"
                      class="w-full"
                      placeholder="Deadline (optional)"
                    />
                    <feather-icon
                      v-if="stocktake.stocktakeDeadlineDate"
                      icon="XIcon"
                      class="ml-1 cursor-pointer"
                      svgClasses="h-5 w-5"
                      @click="stocktake.stocktakeDeadlineDate = null"
                    />
                  </div>
                </template>
              </v-date-picker>
            </div>
          </div>

          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Products</span>
            </div>
            <div>
              <vs-table
                :data="filteredProducts"
                style="margin-left: -24px; margin-right: -24px"
                noDataText=""
              >
                <!--     <template slot="header">
                  <h3 class="ml-6 mb-1">Products</h3>
                </template> -->
                <template slot="thead">
                  <!--                   <vs-th sort-key="namne"> Number </vs-th> -->
                  <vs-th sort-key="amount"> Name </vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                    <!--                <vs-td>
                      <div>{{ tr.name }}</div>
                      <div>
                        <small class="text-grey">{{
                          tr.stockProductId.id
                        }}</small>
                      </div>
                    </vs-td> -->

                    <vs-td>
                      <span class="text-muted"> {{ tr.displayName }}</span>
                    </vs-td>

                    <vs-td>
                      <feather-icon
                        @click="removeProduct(tr.stockProductId.id)"
                        icon="TrashIcon"
                        class="cursor-pointer mr-2"
                        svgClasses="h-5 w-5 stroke-2"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <p v-for="id in stocktake.stockProductIds" :key="id">{{ id }}</p> -->
              <div class="flex justify-center mt-2">
                <vs-button
                  class="ml-2 py-2 px-3 rounded"
                  @click="$refs.popupAddProduct.show()"
                >
                  Add product
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{
          "Submit"
        }}</vs-button>
        <vs-button type="border" color="danger" @click="isActive = false"
          >Cancel</vs-button
        >
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/recount-icon.png";
import { mapGetters } from "vuex";
import { DatePicker } from "v-calendar";
import PopupAddProduct from "./PopupAddProduct.vue";

export default {
  components: {
    DatePicker,
    VuePerfectScrollbar,
    PopupAddProduct,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      ProductIcon,

      isActive: false,
      isLoading: true,
      existingStocktake: null,

      stocktake: null,
    };
  },
  computed: {
    ...mapGetters({
      activeVenueId: "venues/activeVenueId",
      totalVenueStock: "stockProducts/totalVenueStock",
    }),
    isFormValid() {
      return true;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    isRecount() {
      return this.stocktake && this.stocktake.previousStocktakeId != null;
    },
    filteredProducts() {
      console.log("filteredProducts", this.stocktake.stockProductIds);
      if (!this.stocktake) return [];
      return this.totalVenueStock.filter((x) =>
        this.stocktake.stockProductIds.includes(x.stockProductId.id)
      );
    },
  },
  methods: {
    removeProduct(id) {
      this.stocktake.stockProductIds = this.stocktake.stockProductIds.filter(
        (x) => x !== id
      );
    },
    productSelected(productId) {
      console.log("Adding", productId);
      this.stocktake.stockProductIds.push(productId);
    },
    async fromExisting(existingStocktake) {
      this.existingStocktake = existingStocktake;
      const deviatingProductIds =
        existingStocktake.stocktakeDeviations.stocktakeProductDeviations.map(
          (x) => x.stockProductId.id
        );
      this.stocktake = {
        stockTakeId: null,
        stocktakeDeadlineDate: null,
        stockProductIds: deviatingProductIds
      };

      this.isActive = true;
      await this.loadExternalData();
      this.isLoading = false;
    },
    async newStocktake() {
      this.existingStocktake = null;
      this.stocktake = {
        stockTakeId: null,
        stocktakeDeadlineDate: null,
        stockProductIds: [],
      };

      this.isActive = true;
      await this.loadExternalData();
      this.isLoading = false;
    },

    async loadExternalData() {
      await this.$store.dispatch(
        "stockProducts/getTotalVenueStock",
        this.activeVenueId
      );
      console.log("Total venue stock", this.totalVenueStock);
    },

    async submitData() {
      console.log("Submitting DTO", this.stocktake);
      var result = await this.$store.dispatch(
        "stocktakes/createCustomStocktake",
        { venueId: this.activeVenueId, stocktake: this.stocktake }
      );
      if (result) {
        this.$vs.notify({
          title: "Stocktake created",
          text: "Your stocktake has been created",
        });
      } else {
        this.$vs.notify({
          title: "Error",
          text: "Failed to create stocktake",
        });
      }
      this.stocktake = null;
      this.isActive = false;
      this.isLoading = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>